import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinComma',
    standalone: true
})
export class JoinCommaPipe implements PipeTransform {
    transform(list: string[]): string {
        return list && list.length > 0 ? list.map((item) => item).join(', ') : '-';
    }
}
